import { ReactComponent as AddToComparisonIcon } from './comparison.svg';

export default AddToComparisonIcon;
